import { Injectable } from '@angular/core';
import PocketBase from 'pocketbase';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PocketbaseService {
  private readonly pb: PocketBase = new PocketBase(environment.pocketbaseUrl);

  getPocketBase() {
    return this.pb;
  }
}
